export enum SoilAnalysisDesignations {
  alBez = 'Al-bezetting',
  bemLaag = 'Bemonsterde laag',
  bodemLeven = 'Bodemleven',
  bPae = 'B-PAE',
  cnRatio = 'C/N-ratio',
  csRatio = 'C/S-ratio',
  caBez = 'Ca-bezetting',
  cAnorg = 'C-anorganisch',
  capae = 'Ca-PAE',
  caVoorraad = 'Ca-voorraad',
  cecBez = 'CEC-bezetting',
  cecKleiHumus = 'CEC-klei-humus',
  copae = 'Co-PAE',
  cOrg = 'C-organisch',
  cuPae = 'Cu-PAE',
  fePae = 'Fe-PAE',
  hBez = 'H-bezetting',
  kMgRation = 'K/Mg-ratio',
  kBez = 'K-bezetting',
  kGetal = 'K-getal',
  kHCl = 'K-HCl',
  koolzureKalk = 'Koolzure kalk',
  kPae = 'K-PAE',
  kVoorraad = 'K-voorraad',
  lutum = 'Lutum',
  mgBez = 'Mg-bezetting',
  mgPae = 'Mg-PAE',
  mnPae = 'Mn-PAE',
  moPae = 'Mo-PAE',
  naBez = 'Na-bezetting',
  naPae = 'Na-PAE',
  nh4nDrg = 'NH4-Ndrg',
  nlv = 'NLV',
  nMinVrdVv = 'N-min vrd vv',
  no3NDrg = 'NO3-N drg',
  nTot = 'N-totaal',
  nVrd = 'N-Vrd',
  orgStof = 'Organische stof',
  pAl = 'P-AL',
  pHCaCl2 = 'pH-CaCl2',
  pHKCl = 'pH-KCl',
  pPae = 'P-PAE',
  pw = 'Pw',
  sAanvoer = 'S-aanvoer',
  seGetal = 'Se-getal',
  sePae = 'Se-PAE',
  silt = 'Silt',
  siPae = 'Si-PAE',
  sLevVerm = 'S-leverend vermogen',
  sPae = 'S-PAE',
  sTot = 'S-totaal',
  zand = 'Zand',
  znPae = 'Zn-PAE',
}
